import React, {Component} from 'react';
import {Avatar, message, Table, Typography} from 'antd';
import {LoadingIcon} from '../../components/loading';
import UserRepo from '../../repository/user';
import RevokeKey from './component/revoke-key';

const { Title } = Typography;

class UserIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
    }
  }

  componentDidMount() {
    this.fetchUsers();
  }

  fetchUsers() {
    UserRepo.all().then(
      result => {
        this.setState({
          users: result.data.users,
        })
      },
      error => {
        console.log(error.response);
        message.error('Error fetching users')
      }
    )
  }

  render() {
    const columns = [
      {
        title: "",
        key: "avatar",
        render: record => {
          return <Avatar src={record.picture} />
        },
        width: 30,
      },
      {
        title: "Name",
        key: "name",
        dataIndex: "name",
      },
      {
        title: "E-mail",
        key: "email",
        dataIndex: "email",
      },
      {
        title: "",
        key: "action",
        render: record => {
          return (
            <div>
              <RevokeKey user={record} />
            </div>
          )
        }
      }
    ];

    return (
      <>
        <Title level={2}>Users</Title>

        <Table
          dataSource={this.state.users}
          loading={{
            indicator: LoadingIcon,
            tip: "Loading...",
            size: "large",
            spinning: this.state.users.length < 1,
          }}
          rowKey="id"
          pagination={false}
          columns={columns}
        />
      </>
    );
  }
}

export default UserIndex;